import { Configuration, DefaultApi } from '@softcery/qc-apiclient/index'
import { config } from '../config'

export const apiService = new DefaultApi(new Configuration(config))
